import React from "react";

function ringColor(score) {
  if (score >= 90) return "#10B981";
  if (score >= 75) return "#2563EB";
  if (score >= 60) return "#F59E0B";
  return "#EF4444";
}

export function ScoreRing({ score = 0, size = 44, label }) {
  const s = Math.max(0, Math.min(100, Math.round(score)));
  const stroke = 3;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = (s / 100) * c;
  const color = ringColor(s);
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="score-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(148,163,184,0.35)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 0.6s ease-out" }}
        />
      </svg>
      <span className="absolute font-bold text-ink" style={{ fontSize: size * 0.3 }}>
        {label ?? s}
      </span>
    </div>
  );
}
